import {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {matchRoutes, useLocation, useNavigate} from 'react-router-dom'
import {Text} from "@fluentui/react-components"
import "./styles.css"
import Section from "./Section"
import {
    makeStyles,
    shorthands,
    Tab,
    TabList,
    Button,
    TabListProps,
  } from "@fluentui/react-components";

  const Home = (props)=>{
    return <div className="ms-Grid">
        <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm3 ms-lg1"></div>
            
            <div className="ms-Grid-col ms-sm12 ms-lg5">
            <br/>
            <br/>

            <br/>
                <Text size={1000} style={{fontFamily:props.font}}  >Hi<br/>I'm Rauf</Text> <br/>

                <Text size={600} style={{fontFamily:props.font}}>I'm a recently graduated software engineer with a passion for machine learning. Over the past 3 years, I've been dedicated to exploring the fascinating realm of artificial intelligence, particularly the intricacies of the human brain and the mechanics of learning.</Text>
            </div>

            <div className="main-div ms-Grid-col ms-sm6 ms-lg6">
            <img className="main_image" style={{    
                    width:"40vw", 
                    // height:"92.5vh",
                    display:"block",
                    objectFit:"cover",
                    userDrag:"none",
                    pointerEvents:'none',
                    position:"relative"
                }} src={process.env.PUBLIC_URL+"/face.png"}/>
            </div>

        </div>

        {/* projects section */}
        <div className="ms-Grid-row"><div className="ms-Grid-col ms-sm1"></div>
            <div className="ms-Grid-col ms-sm12 ms-lg4"><img src={process.env.PUBLIC_URL+"/wave.png"}/>
        </div></div>
        <Section font={props.font} title="Prominent Projects" type="project" filter={{type:"project", isSection:true}}/>
        <div className="ms-Grid-row"><div className="ms-Grid-col ms-sm9"></div>
            <Link to="/projects" style={{textDecoration:"none"}} target="_blank">
                <Button appearance="primary" size="large" style={{marginTop:"2.5%" , fontFamily:props.font}}>More Projects</Button>
            </Link>
        </div>
        {/* CONTENT SECTION */}

        <div className="ms-Grid-row"><div className="ms-Grid-col ms-sm8"></div>
            <div className="ms-Grid-col ms-sm12 ms-lg4"  style={{marginTop:"3.5%"}}><img src={process.env.PUBLIC_URL+"/wave.png"}/>
        </div></div>
        <Section  font={props.font}title="Content" type="content" filter={{type:"content", isSection:true}}/>
        <div className="ms-Grid-row"><div className="ms-Grid-col ms-sm9"></div>
            <Link to="/content" style={{textDecoration:"none"}} target="_blank">
            <Button appearance="primary" size="large" style={{marginTop:"2.5%" , fontFamily:props.font}}>More Content</Button>
            </Link>
        </div>
        {/*  */}
        <div className="ms-Grid-row"><div className="ms-Grid-col ms-sm1"></div>
            <div className="ms-Grid-col ms-sm12 ms-lg4"><img src={process.env.PUBLIC_URL+"/wave.png"}/>
        </div></div>
    </div>
  }
export default Home